import React from "react";
import MyCarousel from "../../components/MyCarousel";

const Rules = ({ showRules }) => {
  return <MyCarousel showRules={showRules} />;
};

export default Rules;
